import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import '../../../CSS/Empleados.css'
import Select from 'react-select';
import {URI} from '../../../Conexiones/Conexion';
import { BsPlus } from 'react-icons/bs';
import { getToken } from '../../../Conexiones/Conexion';
import moment from 'moment';

const ModalAgregarAlmacen = () => {
  
    const [bodega,setBodega]=useState('')
    const resIdCat =  parseInt(sessionStorage.getItem("idCM"))
    const resNomCat =  sessionStorage.getItem("nomCM")
    const [categorias, setCategorias] = useState([])
    const numObra=parseInt(sessionStorage.getItem("obra"));
    const [materiales,setMateriales]=useState([])
    const [bod,setBod]=useState([])
    const [carritoMat,setCarritoMat]=useState([])
    const [fecha, setFecha] = useState()
    const [nota, setNota] = useState()
    const [catId, setCatId] = useState(resIdCat)
    const [catNom, setCatNom] = useState(resNomCat)
    const [nombreObra,setNombreObra] = useState ('')
    const [tablaMateriales,setTablaMateriales]=useState([])
    const [busqueda,setBusqueda] = useState ('')
    let suma=0

    //const idProyecto =  sessionStorage.getItem("proyecto")
    //console.log(idProyecto)

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = tablaMateriales.filter((elemento)=> {
        if  (elemento.nombreMat.toString().toLowerCase().includes(textoIngresado.toLowerCase())
        ){  return elemento; }
        return resultadoBusqueda
        });
        setMateriales(resultadoBusqueda);
    }


    const agregarEntrada = async (e) =>{
        if(bodega===''){
            Swal.fire({
                title: '¡ERROR!',
                text:'FALTA SELECCIONAR UNA BODEGA...',                 
                icon: 'error',
                confirmButtonColor: 'red',
                confirmButtonText: 'ACEPTAR'
            })
        }else if (fecha===undefined){
            Swal.fire({
                title: '¡ERROR!',
                text:'FALTA SELECCIONAR UNA FECHA...',                 
                icon: 'error',
                confirmButtonColor: 'red',
                confirmButtonText: 'ACEPTAR'
            })
        }else if (nota===undefined){
            Swal.fire({
                title: '¡ERROR!',
                text:'FALTA AGREGAR NÚMERO DE NOTA...',                 
                icon: 'error',
                confirmButtonColor: 'red',
                confirmButtonText: 'ACEPTAR'
            })
        }else{
            const  arregloJson = JSON.stringify(carritoMat)
            e.preventDefault()
            await axios.post(URI+'entradas/',{listaCarrito:arregloJson,idObra:numObra,
                bodega:bodega,fecha:fecha,nota:nota,idU:"sistema"},{
                    headers: {
                        'Content-Type': 'application/json',
                    }}).then(
            res => {                
                console.log(res.data.message)
                if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                    console.log('error conexion')
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                      )
                }else{
                    const mensaje=res.data.message
                    console.log(mensaje)
                    if (mensaje==="Registro creado correctamente"){
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'Entrada de material, exitosa',
                            showConfirmButton: true,
                            //timer: 2000
                          }).then((result) => {
                            
                            if (result.isConfirmed) {
                                window.location.reload();
                            } 
                          })
                    }else if(mensaje==="NOTA EXISTENTE"){
                        Swal.fire({
                            position: 'top-end',
                            icon: 'error',
                            title: mensaje,
                            confirmButtonColor: 'red',
                            confirmButtonText: 'ACEPTAR'
                        })
                    }else{
                        Swal.fire({
                            position: 'top-end',
                            icon: 'error',
                            title: 'ERROR',
                            confirmButtonColor: 'red',
                            confirmButtonText: 'ACEPTAR'
                          })
                    }
                   
    
                }
            }
            ).catch(
                err => {
                    console.log(err);
                    console.log(err.message)
                    console.log(typeof(err.message))
                    if(err.message === "Network Error"){
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                        )
                    }
                }
            )
        }
}
    
    const agregarCarrito =(idMat,nombre)=>{
        var cantidad = parseFloat(document.getElementById(`m${idMat}`).value)
        var precio = parseFloat(document.getElementById(`d${idMat}`).value)
        if(document.getElementById(`m${idMat}`).value==='' || document.getElementById(`d${idMat}`).value===''){
                Swal.fire({
                    title: '¡ERROR!',
                    text:'CAMPOS VACIOS...',                 
                    icon: 'error',
                    confirmButtonColor: 'red',
                    confirmButtonText: 'ACEPTAR'
                })
        }else{
            if(cantidad<=0 || precio<=0){
                Swal.fire({
                    title: '¡ERROR!',
                    text:'LA CANTIDAD INGRESADA DEBE SER MAYOR A 0...',                 
                    icon: 'error',
                    confirmButtonColor: 'red',
                    confirmButtonText: 'ACEPTAR'
                })
            }else{
                const newMat = {
                    precio:precio,
                    cantidad:cantidad,
                    material:idMat,
                    nombre:nombre
                }
                    setCarritoMat([...carritoMat,newMat])

                var input = document.getElementById(`m${idMat}`);
                input.value = null
                
                var input2 = document.getElementById(`d${idMat}`);
                input2.value = null
                }
        }
    }

    const totalMat=(lista)=>{
        for (var j = 0; j < lista.length; j++){
            suma+= parseFloat(lista[j].cantidad*lista[j].precio)
        }
        return suma;
    }

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

     const eliminarCarrito =(id)=>{
        const deleteCarrito = carritoMat.filter((material)=>
        material.material !== id);
        setCarritoMat(deleteCarrito);
    }
    useEffect( ()=>{
        const getAllCategorias = async () =>{
            const res = await axios.get(URI+'catmat/',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                })
            setCategorias(res.data)
        }
        getAllCategorias()
    }, [])

    const handleSelectChange2 = (event) =>{
        console.log("bodega "+event.value)
        setBodega(event.value)
    }

    useEffect (()=>{
        getMateriales()
    },[])

    const getMateriales = async () =>{
        const res = await axios.get(URI+'mat/',{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            })
        setMateriales(res.data)
        setTablaMateriales(res.data)
    }

    useEffect (()=>{
        getBodegas()
    },[])

    const getBodegas = async () =>{
        const res = await axios.get(URI+'bodegas/',{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            })
        setBod(res.data)
        //console.log(res.data)
    }
    
    const handleHer = ( catId, catNom) =>{
        sessionStorage.setItem("idCM",catId)
        sessionStorage.setItem("nomCM",catNom)
        const resId =  parseInt(sessionStorage.getItem("idCM"))
        const resNom =  sessionStorage.getItem("nomCM")
        setCatId(resId)
        setCatNom(resNom)
    }

    useEffect (()=>{
        const getObra = async () =>{
            const res=  await axios.get(URI+'/obras/'+numObra,{
              headers: {
                  'Authorization': `Bearer ${getToken()}`
              },
              })
              setNombreObra(res.data.nombreObra)
          }
        getObra()
    },[numObra])

    
   

    const cancelar = async () => {
        if(carritoMat.length === 0 ){
            window.location.reload()
        }else{
            Swal.fire({
                title: '¿SEGURO QUE QUIERES SALIR?',
                text: "UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS",
                icon: 'warning',
                iconColor:'#1e2c4f',
                color: '#1e2c4f',
                showCancelButton: true,
                confirmButtonColor: '#1e2c4f',
                cancelButtonColor: '#d33',
                confirmButtonText: 'SALIR',
                cancelButtonText: 'CANCELAR'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })   
        } 
    }
    const getFecha = () =>{
        const date= moment (new Date());
        return(date.tz('America/Mexico_City').format('YYYY-MM-DD'))
    }

    return (
 <div>
        <div className="modal fade" id="modalEntrada" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title " id="exampleModalLabel">ENTRADA DE MATERIALES A OBRA</h5>
                        <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                
                    <div className="modal-body" >
                        <div className="mb-3">
                            <h5 className="modal-title text-uppercase" id="exampleModalLabel">{nombreObra}</h5>
                        </div>

                        <div className='row' style={{justifyContent:"center"}}>
                                        <div className='col-md-3'>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">CATEGORIA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                                <div className="dropdown" >
                                                    {catNom === null ? (
                                                    <button className="btn btn-secondary dropdown-toggle text-uppercase" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    CATEGORIA
                                                    </button>):( <button className="btn btn-secondary dropdown-toggle text-uppercase" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {catNom}
                                                    </button>)}
                                                    <ul className="dropdown-menu">
                                                        {categorias.map(categoria =>{
                                                            return(
                                                                <li key={categoria.idCatMat} >
                                                                    <button className="dropdown-item text-uppercase" onClick={()=> handleHer(categoria.idCatMat,categoria.nombreCatMat)} >
                                                                        {categoria.nombreCatMat}
                                                                    </button>
                                                                </li>
                                                            )
                                                        })}                                   
                                                    </ul>
                                                    </div>  
                                        </div>
                                        <div className='col-md-3'>
                                                <div >
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                                    <input type="date" className="form-control" max={getFecha()} onChange={e => setFecha(e.target.value) } id="exampleFormControlInput1" required/>
                                                </div>
                                        </div>

                                        <div className='col-md-3'>      
                                            <div className="text-uppercase"  style={{marginTop:"8px"}}>
                                                    <label htmlFor="exampleFormControlInput1" > bodega <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            placeholder="Seleccionar..."
                                                            required
                                                            options={bod.map(tip=>({label:tip.nombreBod,value:tip.idBodega}))}
                                                            onChange={handleSelectChange2}
                                                        />
                                            </div>
                                        </div>

                                        <div className='col-md-3'>      
                                            <div className="text-uppercase"  style={{marginTop:"8px"}}>
                                                    <label htmlFor="exampleFormControlInput1" > NO. NOTA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                                    <input type="text" className="form-control"  onChange={e => setNota(e.target.value)} id="exampleFormControlInput1" required/>
                                            </div>
                                        </div>

                        </div>
                        <div style={{width:'100%'}}>
                        <input type="search" placeholder="Nombre del material" value={busqueda} onChange={buscar} className="form-control buscarMat" aria-describedby="basic-addon1"/>                                     
                                <div className='lista1' >
                                     <div className="table-responsive text-uppercase" style={{marginRight:"10px",textAlign:"center"}}>
                                        <table className="table">
                                        <thead >
                                                <tr>
                                                    <th >MATERIAL</th>
                                                    <th >CANTIDAD</th>
                                                    <th >PRECIO(UNIDAD)</th>
                                                    <th>AGREGAR</th>
                                                </tr>
                                        </thead>
                                    <tbody >
                                        { materiales.map( entrada => {
                                                return (
                                                    entrada.idCatMat === catId ? (
                                                        <tr key={entrada.idMaterial}>
                                                        <td>{entrada.nombreMat}</td>
                                                        <td><form> <input required id={`m${entrada.idMaterial}`} style={{width:"50px"}}  > 
                                                        </input> 
                                                        </form>
                                                        </td> 
                                                        <td><form> <input required id={`d${entrada.idMaterial}`} style={{width:"50px"}}  > 
                                                        </input> 
                                                        </form>
                                                        </td>
                                 
                                                        <td> <button  className="btn  btncolor" style={{width:"40px",padding:"5px"}} type="button"  onClick={() => agregarCarrito(entrada.idMaterial,entrada.nombreMat)}>
                                                        <BsPlus  style={{fontSize:'30px'}}/>    
                                                        </button> </td>                                     
                                                        </tr>
                                                           ):(null)
                                                    )
                                            })}
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{justifyContent:"space-between",display:"flex"}}>
                                <b style={{marginRight:"15px",marginLeft:"15px"}}>AGREGADOS</b>
                                <b style={{marginRight:"15px",marginLeft:"15px"}}>{'TOTAL: $ '+formato(totalMat(carritoMat))}</b>
                            </div>
                            <div className='lista2' >
                                <div className="table-responsive text-uppercase" style={{backgroundColor:'#efefef', borderRadius:'15px'}}>
                                    {carritoMat.length === 0  ?(<div><p>VACIO</p></div>):(
                                    <table className="table" >
                                        <thead >
                                            <tr>
                                                <th >MATERIAL</th>
                                                <th >CANTIDAD</th>
                                                <th >PRECIO(UNIDAD)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { carritoMat.map( tipo => {
                                            return (
                                                    <tr key={tipo.material}>
                                                    <td>{tipo.nombre}</td>
                                                    <td>{tipo.cantidad}</td>
                                                    <td>${tipo.precio}</td>
                                                    <td>
                                                        <div>
                                                                    <div className="btn iconoH"  onClick={() => eliminarCarrito(tipo.material)}
                                                                    style={{color:'red', cursor:'pointer'}}>
                                                                            <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                    </div>                                     
                                                        </div>
                                                    </td>
                                                    </tr>
                                            )})
                                        }
                                        </tbody>
                                    </table>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                        <div className="modal-footer justify-content-center" style={{clear:'both'}}>
                        <button type="button" className="btn btn-secondary" onClick={cancelar} >CANCELAR</button>
                            {carritoMat.length === 0 ? (
                                <button type="button" className="btn btn-light btncolor" disabled>ACEPTAR</button> 
                            ):(
                                <button type="button" className="btn btn-light btncolor" onClick={agregarEntrada}  >ACEPTAR</button>
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>
                </div>
    );
};

export default ModalAgregarAlmacen;